export default __webpack_public_path__ + "static/tt-norms-medium-2d708090f0824940d6028e49c62bf220.woff2";